import { configureStore, combineReducers } from '@reduxjs/toolkit'
import type { ThunkDispatch, Action, ThunkAction, AnyAction, Reducer } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'reduxjs-toolkit-persist'
import storage from 'reduxjs-toolkit-persist/lib/storage'
import autoMergeLevel1 from 'reduxjs-toolkit-persist/lib/stateReconciler/autoMergeLevel1'
import common from './slices/common'
// import 'hoodash'

// * common reducer
const commonPersistConfig = {
  key: 'common',
  storage,
  // blacklist: []
  // whitelist: []
  stateReconciler: autoMergeLevel1,
  timeout: 1
}

const commonReducer: Reducer<ReturnType<typeof common>, AnyAction> = persistReducer<
  ReturnType<typeof common>,
  AnyAction
>(commonPersistConfig, common)

// * other reducer
// ... ...

// * 合并reducer
const reducer = combineReducers({
  common: commonReducer
})

const store = configureStore({
  reducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        /* ignore persistance actions */
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(logger as any)
})

export type AppDispatchType = typeof store.dispatch
export type RootStateType = ReturnType<typeof store.getState>

export type AppThunkDispatchType = ThunkDispatch<RootStateType, unknown, Action<string>>
export type AppThunkActionType<ReturnType = void> = ThunkAction<ReturnType, RootStateType, unknown, Action<string>>

// 用于持久化
export const persistor = persistStore(store)

export default store
